import ReportMarketingList from './report-players-mkt-campaign-usage.list';

export default {
  list: ReportMarketingList,
};
